module.exports = __webpack_public_path__ + "img/bb-price.2255474.png";